import React, { useState } from 'react';
import { MuiThemeProvider, Table, TableBody } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { documentSignerTheme } from 'common/shared/oldDocumentSignerUI/theme';

import Toolbar from './Toolbar';
import TableHead from './TableHead';
import TableRow from './TableRow';
import RowMenu from './RowMenu';
import TableFooter from './TableFooter';

const styles = theme => ({
  header: {
    marginBottom: theme.spacing.unit * 2.6,
  },
});

const DocumentManagement = props => {
  const {
    classes,
    data,
    handleActiveFlag,
    handleEdit,
    handleOpenDocViewer,
    handleReplace,
    length,
  } = props;

  const [contextMenuAnchor, setContextMenuAnchor] = useState(null);
  const [contextualMenuDoc, setContextualMenuDoc] = useState(null);

  const closeContextMenu = () => setContextMenuAnchor(null);

  const handleOpenMenu = (ev, newContextualMenuDoc) => {
    setContextMenuAnchor(ev.currentTarget);
    setContextualMenuDoc(newContextualMenuDoc);
  };

  return (
    <MuiThemeProvider theme={documentSignerTheme}>
      <div className={classes.root}>
        <Toolbar />
        <Table>
          <TableHead />
          <TableBody>
            {data.map(item => (
              <TableRow item={item} handleOpenMenu={handleOpenMenu} />
            ))}
          </TableBody>
          <TableFooter length={length} />
        </Table>
        <RowMenu
          anchorEl={contextMenuAnchor}
          handleOpenDocViewer={id => {
            handleOpenDocViewer(id);
            closeContextMenu();
          }}
          handleCloseMenu={closeContextMenu}
          handleActiveFlag={id =>
            Promise.resolve(handleActiveFlag(id)).then(closeContextMenu)
          }
          handleEdit={id => {
            handleEdit(id);
            closeContextMenu();
          }}
          handleReplace={id => {
            handleReplace(id);
            closeContextMenu();
          }}
          contextualMenuDoc={contextualMenuDoc}
        />
      </div>
    </MuiThemeProvider>
  );
};

export default withStyles(styles)(DocumentManagement);
